import { clearAppUserState } from "../../api/slices/appUser";

export const logout = (options?: { skipTarget?: boolean }): void => {
  // Clear old BioT state
  clearAppUserState();

  // Clear ExtraHorizon tokens from localStorage
  localStorage.removeItem("exh_refresh_token");
  localStorage.removeItem("exh_access_token");
  localStorage.removeItem("exh_token_expiry");

  if (!options?.skipTarget) {
    if (window.location.pathname !== "/login") {
      const target = window.location.pathname;
      if (target === "/") {
        window.location.assign(`/login`);
      } else {
        window.location.assign(`/login?target=${window.location.href}`);
      }
    }
    return;
  }
  window.location.assign("/login");
};
